import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { MetaService } from 'src/shared/servies/meta.service';
import { TitleService } from 'src/shared/servies/title.service';

@Component({
    selector: 'app-grievance-redressal-system',
    templateUrl: './grievance-redressal-system.component.html',
    styleUrls: ['./grievance-redressal-system.component.scss'],
})
export class GrievanceRedressalSystemComponent implements OnInit {
    universityUrl: any;
    course: any = [];
    url: any;
    parts: any;
    lastParam: any;
    displayStyle = 'none';
    displayStyleErr = 'none';
    displayStyleCon = 'none';
    displayStyleEn = 'none';

    ConfirmationSubmit() {
        this.displayStyle = 'block';
    }
    closePopup() {
        window.location.href = window.location.href;
    }
    ErrorDetect() {
        this.displayStyleErr = 'block';
    }
    closePopupError() {
        window.location.href = window.location.href;
    }

    divdis(a) {
        if (a == '1') {
            this.displayStyleCon = 'none';
            this.displayStyleEn = 'block';
            this.ConsultancyCode.setValue('0');
            this.EnrollmentNo.setValue('');
        } else if (a == '2') {
            this.displayStyleCon = 'block';
            this.displayStyleEn = 'none';
            this.EnrollmentNo.setValue('0');
            this.ConsultancyCode.setValue('');
        } else {
            this.displayStyleCon = 'none';
            this.displayStyleEn = 'none';
            this.EnrollmentNo.setValue('0');
            this.ConsultancyCode.setValue('0');
        }
    }
    constructor(
        private activatedRoute: ActivatedRoute,
        private titleService: TitleService,
        private titleLibraryService: Title,
        private metaServices: MetaService,
        private metaService: Meta,
        private http: HttpClient
    ) {
        this.url = window.location.pathname;
        this.parts = this.url.split('/');
        this.lastParam = this.parts[this.parts.length - 1];
    }

    ngOnInit(): void {
        this.getStudentSupportTitle();

        this.divdis('1');
        this.QueryBy.setValue('1');
    }
    GrievanceForm = new FormGroup({
        Studentname: new FormControl('', Validators.required),
        FatherName: new FormControl('', Validators.required),
        DOB: new FormControl(''),
        // Attachment : new FormControl(''),
        EnrollmentNo: new FormControl('', Validators.required),
        ConsultancyCode: new FormControl(''),

        Department: new FormControl('', Validators.required),
        QueryBy: new FormControl('', Validators.required),
        email: new FormControl('', [Validators.required, Validators.email]),
        ContactNo: new FormControl('', [
            Validators.required,
            Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
        ]),
        Message: new FormControl('', [
            Validators.required,
            Validators.minLength(10),
        ]),
    });

    get Studentname() {
        return this.GrievanceForm.get('Studentname');
    }
    get FatherName() {
        return this.GrievanceForm.get('FatherName');
    }
    get email() {
        return this.GrievanceForm.get('email');
    }
    get ContactNo() {
        return this.GrievanceForm.get('ContactNo');
    }
    get Message() {
        return this.GrievanceForm.get('Message');
    }
    get EnrollmentNo() {
        return this.GrievanceForm.get('EnrollmentNo');
    }
    get Department() {
        return this.GrievanceForm.get('Department');
    }
    get ConsultancyCode() {
        return this.GrievanceForm.get('ConsultancyCode');
    }
    get QueryBy() {
        return this.GrievanceForm.get('QueryBy');
    }

    onSubmit(data) {
        this.http
            .post(
                'https://api.ddesubharti.com/api/v1/Grievance/AddGrivancecomplaints',
                data
            )
            // this.http.post('https://localhost:44383/api/v1/Grievance/AddGrivancecomplaints',data)

            .subscribe((result) => {
                if (result != null) {
                    this.ConfirmationSubmit();
                } else {
                    this.ErrorDetect();
                }
            });
    }
    getStudentSupportTitle() {
        this.titleService.getStudentSupportTitleJson().subscribe((res) => {
            this.course = res.titles;
            console.log('this.course', this.course);
            if (this.lastParam && this.course.length > 0) {
                this.course.forEach(
                    (courseUrl: {
                        twitter_idrmge: string;
                        og_title: string;
                        og_url: string;
                        url: any;
                        title: string;
                        keywords: any;
                        descriptions: any;
                    }) => {
                        if (courseUrl.url === this.lastParam) {
                            this.titleLibraryService.setTitle(courseUrl.title);
                            this.metaService.addTags([
                                {
                                    name: 'keywords',
                                    content: '',
                                },
                                { name: 'description', content: '' },
                                { property: 'og:title', content: '' },
                                { property: 'og:url', content: '' },
                                { property: 'og:type', content: '' },
                                { property: 'og:description', content: '' },
                                { property: 'og:image', content: '' },
                                { property: 'og:ib.scge', content: '' },
                                { property: 'og:im.scge', content: '' },
                                { property: 'og:ib.edge', content: '' },
                                { property: 'og:ib.libge', content: '' },
                                { property: 'og:im.libge', content: '' },
                                {
                                    property: 'og:ima journalismge',
                                    content: '',
                                },
                                { property: 'og:idfmge', content: '' },
                                { property: 'og:idmmge', content: '' },
                                { property: 'og:idrmge', content: '' },
                                { name: 'twitter:card', content: '' },
                                { name: 'twitter:title', content: '' },
                                { name: 'twitter:description', content: '' },
                                { name: 'twitter:url', content: '' },
                                { name: 'twitter:image', content: '' },
                                { name: 'twitter:ib.scge', content: '' },
                                { name: 'twitter:im.scge', content: '' },
                                { name: 'twitter:ib.edge', content: '' },
                                { name: 'twitter:ib.libge', content: '' },
                                { name: 'twitter:im.libge', content: '' },
                                {
                                    name: 'twitter:ima journalismge',
                                    content: '',
                                },
                                { name: 'twitter:idfmge', content: '' },
                                { name: 'twitter:idmmge', content: '' },
                                { name: 'twitter:idrmge', content: '' },
                            ]);

                            this.metaService.updateTag({
                                name: 'keywords',
                                content: courseUrl.keywords,
                            });
                            this.metaService.updateTag({
                                name: 'description',
                                content: courseUrl.descriptions,
                            });
                            this.metaService.updateTag({
                                property: 'og:title',
                                content: courseUrl.og_title,
                            });
                            this.metaService.updateTag({
                                property: 'og:url',
                                content: courseUrl.og_url,
                            });

                            this.metaService.updateTag({
                                name: 'twitter:idmmge',
                                content: courseUrl.twitter_idrmge,
                            });
                            this.metaService.updateTag({
                                name: 'twitter:idrmge',
                                content: courseUrl.twitter_idrmge,
                            });
                        }
                    }
                );
            }
        });
    }
}
